var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "openBookIcon",
    transform: "translate(0 1.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 24,
    height: 24,
    transform: "translate(0 -1.313)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-open",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M10.5,20.4a1.651,1.651,0,0,0-1.648-1.651H1.5a1.5,1.5,0,0,1-1.5-1.5V1.5A1.5,1.5,0,0,1,1.5,0H7.8A5.687,5.687,0,0,1,12,1.85,5.688,5.688,0,0,1,16.2,0h6.3A1.5,1.5,0,0,1,24,1.5V17.248a1.5,1.5,0,0,1-1.5,1.5H15.149A1.653,1.653,0,0,0,13.5,20.4a1.5,1.5,0,0,1-3,0Zm3-14.7V16.052a4.592,4.592,0,0,1,1.648-.3H21V3H16.2A2.7,2.7,0,0,0,13.5,5.7ZM3,15.748H8.852a4.588,4.588,0,0,1,1.648.3V5.7A2.7,2.7,0,0,0,7.8,3H3Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_30",
    "data-name": "Line 30",
    d: "M3.414.5H-.25A.75.75,0,0,1-1-.25.75.75,0,0,1-.25-1H3.414a.75.75,0,0,1,.75.75A.75.75,0,0,1,3.414.5Z",
    transform: "translate(15.816 6.707)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_30-2",
    "data-name": "Line 30",
    d: "M3.414.5H-.25A.75.75,0,0,1-1-.25.75.75,0,0,1-.25-1H3.414a.75.75,0,0,1,.75.75A.75.75,0,0,1,3.414.5Z",
    transform: "translate(15.816 9.624)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_30-3",
    "data-name": "Line 30",
    d: "M3.414.5H-.25A.75.75,0,0,1-1-.25.75.75,0,0,1-.25-1H3.414a.75.75,0,0,1,.75.75A.75.75,0,0,1,3.414.5Z",
    transform: "translate(15.816 12.54)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookIcon);
export default __webpack_public_path__ + "static/media/openBookIcon.3d03efac4b4b34c7f21c170355cb2458.svg";
export { ForwardRef as ReactComponent };